import React, { useState } from "react";

import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

import Swal from "sweetalert2";

// @mui icons

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import UserInfoCard from "./components/UserInfoCard";
import TypeInfoCard from "./components/TypeInfoCard";
import EditUserCard from "./components/EditUserCard";
import TypeButtons from "./components/TypeButtons";

// Overview page components
import Header from "layouts/ManageUsers/UserDetails/components/Header";
import UserSettings from "layouts/ManageUsers/UserDetails/components/UserSettings";

// Data

// Images

import UserManagementApi from "../../../Classes/API/Administration/UserManagementApi";
import SearchStringOrIntReq from "../../../Classes/Models/Requests/SearchStringOrIntReq";
import CreateUserReq2 from "../../../Classes/Models/Requests/Users/CreateUserReq";
import { useContext } from "react";

import { UserContext } from "App";
import { SelectedUserContext } from "./index";
import PatientSingleSessionsTable from "./components/PatientData/UserAccountingSessions";
import PatientPackagesTable from "./components/PatientData/UserPackages";
import UserPatientEntries from "./components/PatientData/UserNotes";
import "./NoramlDetails.scss";

const NormalDetails = ({ GetUserData }) => {
  const User = useContext(SelectedUserContext);
  const CurrentUser = useContext(UserContext);

  console.log("CurrentUser in NormalDetails:", CurrentUser);

  const [EditMode, setEditMode] = useState(false);

  let searchReq = new SearchStringOrIntReq();
  let editUserReq = new CreateUserReq2();

  const EditUser = async (user) => {
    editUserReq.Address = user.address;
    editUserReq.Email = user.email;
    editUserReq.Id = user.id;
    editUserReq.Nationality = user.nationality;
    editUserReq.NationalityGroup = user.nationalityGroup;
    editUserReq.Number = user.number;
    editUserReq.Name = user.name;
    editUserReq.UserType = user.userType;
    editUserReq.isActivated = user.isActivated;
    editUserReq.isAssessmentTherapist = user.isAssessmentTherapist;
    editUserReq.isSoftDeleted = user.isSoftDeleted;

    let res = await UserManagementApi.EditUser(editUserReq);

    if (res.status == "Success") {
      GetUserData(user.id);
    }
  };

  const ToggleSuperAdmin = async (id) => {
    try {
      searchReq.searchInt = id;
      const userRes = await UserManagementApi.GetUserById(searchReq);

      if (userRes.status !== "Success") {
        throw new Error("Failed to fetch user data");
      }

      const payload = {
        FirebaseId: userRes.data.firebaseId,
      };

      const response = await UserManagementApi.ToggleSuperAdmin(payload);

      if (response.status === "Success") {
        await GetUserData(id); // Refresh user data
        Swal.fire({
          title: "Success",
          text: response.message || "Super Admin status updated",
          icon: "success",
          confirmButtonText: "OK",
        });
        return response.data; // Return the new status
      } else {
        throw new Error(response.message);
      }
    } catch (error) {
      console.error("Error toggling Super Admin:", error);
      Swal.fire({
        title: "Error",
        text: error.message || "Failed to update Super Admin status",
        icon: "error",
        confirmButtonText: "OK",
      });
      throw error;
    }
  };

  const AssignTypeToUser = async (user) => {
    // if(user.userType != "Patient" && CurrentUser.userType != "Admin"){
    //   Swal.fire({
    //     title: "Access Denied",
    //     text: "You are not authorized to change this user type",
    //     icon: "error",
    //     confirmButtonText: "OK"
    //   });
    //   return
    // }

    if (user.userType == "Admin" && CurrentUser.userType != "Admin") {
      Swal.fire({
        title: "Access Denied",
        text: "You are not authorized to change this user type",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    editUserReq.Address = user.address;
    editUserReq.Email = user.email;
    editUserReq.Id = user.id;
    editUserReq.Nationality = user.nationality;
    editUserReq.NationalityGroup = user.nationalityGroup;
    editUserReq.Number = user.number;
    editUserReq.Name = user.name;
    editUserReq.UserType = user.userType;
    editUserReq.isActivated = user.isActivated;
    editUserReq.isAssessmentTherapist = user.isAssessmentTherapist;
    editUserReq.isSoftDeleted = user.isSoftDeleted;

    let res = await UserManagementApi.AssignTypeToUser(editUserReq);

    if (res.status == "Success") {
      GetUserData(user.id);
    }
  };

  const SoftDeleteUser = async (id) => {
    searchReq.searchInt = id;
    var res = await UserManagementApi.SoftDeleteUser(searchReq);
    if (res.status == "Success") {
      await GetUserData(id);
    }
  };

  const ToggleUserActivation = async (id) => {
    searchReq.searchInt = id;
    var res = await UserManagementApi.ToggleUserActivation(searchReq);
    if (res.status == "Success") {
      await GetUserData(id);
    }
  };

  console.log(User);

  return (
    <Header User={User}>
      <MDBox mt={5} mb={3}>
        <div className="info-container">
          <Grid container spacing={1}>
            <Grid item xs={12} md={6} xl={4}>
              <UserSettings
                ToggleUserActivation={ToggleUserActivation}
                User={User}
                SoftDeleteUser={SoftDeleteUser}
                EditUser={EditUser}
                AssignTypeToUser={AssignTypeToUser}
                ToggleSuperAdmin={ToggleSuperAdmin}
              />
            </Grid>
            <Grid item xs={12} md={6} xl={4} sx={{ display: "flex" }}>
              <Divider orientation="vertical" sx={{ ml: -2, mr: 1 }} />
              {EditMode ? (
                <EditUserCard setEditMode={setEditMode} />
              ) : (
                <UserInfoCard setEditMode={setEditMode} shadow={false} />
              )}
              <Divider orientation="vertical" sx={{ mx: 0 }} />
            </Grid>
            <Grid item xs={12} md={6} xl={4}>
              {(CurrentUser.userType == "Admin" ||
                CurrentUser.userType === "AccountingEmployee") && (
                <TypeInfoCard GetUserData={GetUserData} />
              )}
            </Grid>
          </Grid>
        </div>

        {
          // if user type is patient show UserAccountingSessions component
          User.userType === "Patient" && (
            <PatientSingleSessionsTable CurrentUser={CurrentUser} patient={User} />
          )
        }

        {
          // if user type is patient show UserPackages component
          User.userType === "Patient" && <PatientPackagesTable patient={User} />
        }

        {User.userType === "Patient" && <UserPatientEntries patient={User} />}
      </MDBox>
      {/* <MDBox pt={2} px={2} lineHeight={1.25}>
      <MDTypography variant="h6" fontWeight="medium">
        More Actions
      </MDTypography>
      <MDBox mb={1}>
        <MDTypography variant="button" color="text">
          Type Specific Search
        </MDTypography>
      </MDBox>
    </MDBox>
    <MDBox p={2}>
      <TypeButtons/>
    </MDBox> */}
    </Header>
  );
};

export default NormalDetails;
